import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  clearFiltersIfEmpty,
  changeIndustrialFilterGroup,
  changePropertyFilterGroup,
  selectAssetClass,
  selectBuildingClass,
  selectInvestmentType
} from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';

import PropertyFilterGroup from 'components/research_property/property_filter_group';

export class CompsPropertyFilterGroup extends React.Component {
  static propTypes = {
    assetClasses: PropTypes.array.isRequired,
    availableRailProviders: PropTypes.array.isRequired,
    buildingClasses: PropTypes.array.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    industrialFilter: PropTypes.object.isRequired,
    investmentTypes: PropTypes.array.isRequired,
    lotBorderTypes: PropTypes.array.isRequired,
    lotStabilizations: PropTypes.array.isRequired,
    propertyFilter: PropTypes.object.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired,
    servedRailProviders: PropTypes.array.isRequired,

    onAssetClassChange: PropTypes.func.isRequired,
    onBuildingClassChange: PropTypes.func.isRequired,
    onIndustrialFilterChange: PropTypes.func.isRequired,
    onInvestmentTypeChange: PropTypes.func.isRequired,
    onPropertyFilterChange: PropTypes.func.isRequired
  }

  render() {
    return (
      <PropertyFilterGroup {...this.props} />
    );
  }
}

const mapStateToProps = state => ({
  addressFilter: state.query.addressFilter,
  assetClasses: state.static.assetClasses,
  availabilities: state.static.availabilities,
  availableRailProviders: state.static.availableRailProviders,
  buildingClasses: state.static.buildingClasses,
  industrialFilter: state.query.industrialFilter,
  investmentTypes: state.static.investmentTypes,
  lotBorderTypes: state.static.lotBorderTypes,
  lotStabilizations: state.static.lotStabilizations,
  propertyFilter: state.query.propertyFilter,
  selectedAssetClasses: state.query.assetClasses,
  selectedAvailabilities: state.query.availabilities,
  selectedBuildingClasses: state.query.buildingClasses,
  selectedInvestmentTypes: state.query.investmentTypes,
  servedRailProviders: state.static.servedRailProviders
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,

  onAssetClassChange: selectAssetClass,
  onBuildingClassChange: selectBuildingClass,
  onIndustrialFilterChange: changeIndustrialFilterGroup,
  onInvestmentTypeChange: selectInvestmentType,
  onPropertyFilterChange: changePropertyFilterGroup
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsPropertyFilterGroup);
